import React, { useEffect } from "react";
import { HashLink } from "react-router-hash-link";

const ScrollTo = ({ to, children }) => {
    // Scroll to the hash target when the link is clicked
    const handleClick = () => {
        // Remove the '#' from the beginning
        const element = document.getElementById(to.substring(1));
        if (element) {
            const offset = element.offsetTop;
            window.scrollTo({ top: offset, behavior: "smooth" });
        }
    };

    useEffect(() => {
        // Scroll to the hash target when the component mounts
        const hash = window.location.hash;
        if (hash !== "") {
            // Remove the '#' from the beginning
            const element = document.getElementById(hash.substring(1));
            if (element) {
                const offset =
                    element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: offset, behavior: "smooth" });
            }
        }
    }, [to]);

    return (
        <HashLink smooth to={to} onClick={handleClick}>
            {children}
        </HashLink>
    );
};

export default ScrollTo;



// WEBPACK FOOTER //
// ./resources/js/components/ScrollTo.js